import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Drawer, notification, Table } from 'antd';
import { CountryCodes } from '@Apis/constants';
import { Helmet } from 'react-helmet';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import TenantActions from '@Actions/tenantActions';
import H3Text from '@Uilib/h3Text';
import TenantForm from '@Components/Common/TenantForm';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import BusinessUnitDetails from './BusinessUnitDetails';
import './style.scss';

class BusinessUnit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      businessUnitColumns: [
        {
          title: 'UNIT NAME',
          render: (text, record) => (
            <H3Text text={`${record.tenant_name ? record.tenant_name : ''}`} className="prod-table__text" />
          ),
        },
        {
          title: 'LOCATION',
          render: (text, record) => (
            <H3Text text={record?.default_billing_address_info?.city ? record?.default_billing_address_info?.city : '-'} className="prod-table__text" />
          ),
        },
        {
          title: 'WORK EMAIL',
          render: (text, record) => (
            <H3Text text={record.email ? record.email : '-'} className="prod-table__text" />
          ),
        },
        {
          title: 'WORK PHONE',
          render: (text, record) => (
            <H3Text text={record?.mobile ? (`${CountryCodes?.find((code) => code?.dial_code == record?.dial_code)?.flag} +${record?.dial_code} ${record?.mobile}`) : '-'} className="prod-table__text" />
          ),
        },
        {
          title: 'GST REGISTRATION',
          render: (text, record) => (
            <H3Text text={record?.gst_number || '-'} className="prod-table__text" />
          ),
        },
        {
          title: 'PAYABLE',
          render: (text, record) => this.props.MONEY(Number(record?.total_grn_value) - Number(record?.total_payment_made) || 0),
        },
        {
          title: '',
          render: (record) => (
            <div
              onClick={() => {
                this.setState({
                  selectedTenant: record,
                  viewBusinessDetails: true,
                });
              }}
              className="bu-list__view-button"
            >
              View
            </div>
          ),

        },
      ],
      showNewRoleModal: false,
      showUpdateRoleModal: false,
      currentPage: 1,
      users: [],
      isUserReady: false,
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.user?.tenant_info?.org_id && !state.isUserReady) {
      props.getTenants(1, '', true, props.user?.tenant_info?.org_id);
      return {
        isUserReady: true,
      };
    }
    if (props.tenants) {
      const array = props?.tenants?.tenant?.filter(
        (item) => item?.tenant_id === props?.user?.tenant_info?.tenant_id,
      );
      const users = array?.[0]?.tenant_users;
      const uniqueRoles = [];
      for (let i = 0; i < users?.length; i++) {
        if (!uniqueRoles.includes(users[i].role_id)) {
          uniqueRoles.push(users[i].role_id);
        }
      }
      return {
        ...state,
        users: array?.[0]?.tenant_users || [],
        uniqueRoles,
      };
    }
    return state;
  }

  render() {
    const {
      user, getTenantsLoading, tenants, getTenants,
    } = this.props;
    const {
      businessUnitColumns, selectedTenant, viewBusinessDetails, showNewTenantModal,
    } = this.state;
    const subscription = user?.tenant_info?.global_config?.settings;
    const activeTenants = tenants?.data?.filter(i=>i?.is_active) || [];
    return (
      <Fragment>
        <Drawer
          open={showNewTenantModal}
          onClose={() => this.setState({ showNewTenantModal: false })}
          width="600px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '555px' }}>
              <H3Text text="Add New Business Unit" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showNewTenantModal: false })} />
            </div>
          </div>
          <TenantForm
            callback={() => {
              this.setState({ showNewTenantModal: false });
              getTenants(1, '', true, user?.tenant_info?.org_id);
            }}
          />
        </Drawer>
        {viewBusinessDetails
          ? (
            <BusinessUnitDetails
              selectedTenant={selectedTenant}
              changeTenant={(value) => this.setState({ selectedTenant: value })}
              onClose={() => { this.setState({ viewBusinessDetails: false }); }}
            />
          )
          : (
            <div className="doc-list__wrapper">
              <div className="ant-row">
                <div className="ant-col-md-24">
                  <div className="doc-list__table-wrapper">
                    <Table
                      title={() => (
                        <div className="doc-list__table-header">
                          <div className="doc-list__table-header__left align-content-center">
                            <H3Text text={`${activeTenants?.length || '0'} Business Units `} className="" />
                          </div>
                            <div className="doc-list__table-header__right">
                              <div className="doc-list__buttons-wrapper">
                                <H3Button
                                  buttonType={defaultButtonTypes.BLUE_ROUNDED}
                                  text="+ Add Business Unit"
                                  onClick={() => {
                                    if (activeTenants.length >= user?.tenant_info?.global_config?.settings?.business_unit_limit) {
                                      notification.error({
                                        message: `Please upgrade your subscription. You have an active subscription of ${user?.tenant_info?.global_config?.settings?.business_unit_limit} business units only.`,
                                        placement: 'top',
                                        duration: 4,
                                      });
                                    } else {
                                      this.setState({ showNewTenantModal: true });
                                    }
                                  }}
                                  customClass="add-button"
                                />
                              </div>
                            </div>
                        </div>
                      )}
                      showHeader
                      loading={getTenantsLoading}
                      size="small"
                      columns={businessUnitColumns}
                      dataSource={activeTenants || []}
                      currentPage
                      pagination={activeTenants?.length > 10 ? {
                        defaultCurrent: 1,
                        total: activeTenants?.length ? activeTenants?.length : 0,
                        pageSize: 10,
                        position: ['bottomRight'],
                        showSizeChanger: false,
                      } : false}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}

      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers, TenantReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  users: TenantReducers.users,
  tenants: TenantReducers.tenants,
  getTenantsLoading: TenantReducers.getTenantsLoading,
  getUsersLoading: UserReducers.getUsersLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getUsers: (tenantId, roleId) => dispatch(TenantActions.getUsers(tenantId, roleId)),
  getTenants: (page, keyword, isVerified, orgId) => dispatch(
    TenantActions.getTenants(page, keyword, isVerified, orgId),
  ),

});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BusinessUnit));
